var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border":"0px solid gray","margin":"0"}},[_c('div',{staticClass:"resize-forward-chart",attrs:{"id":_vm.divName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }